// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5k-1";
export var standaloneTable = "_5k-0";